/* Spielerstatus — die sechs Zustände, in denen ein Spieler sein kann.
 *
 * Reine Daten und reine Funktionen: keine Texte, kein DOM. Die Beschriftungen
 * liegen in den Sprachdateien unter status.<key>, weil sie übersetzt werden.
 */

export const STATUS_ORDER = ['camp', 'trial', 'nt', 'injured', 'transferred', 'released'];

/** Status, bei denen der Spieler den Verein verlassen hat. */
export const STATUS_OUT = ['transferred', 'released'];

/** Farbrolle je Status — auf die Theme-Tokens gemappt, nicht auf feste Farbwerte. */
export const STATUS_COLOR = {
  camp: 'success',
  trial: 'warning',
  nt: 'info',
  injured: 'error',
  transferred: 'neutral',
  released: 'error',
};

export function isOutOfSquad(status) {
  return STATUS_OUT.includes(status);
}

export function nextStatusOf(status) {
  const i = STATUS_ORDER.indexOf(status);
  return STATUS_ORDER[(i + 1) % STATUS_ORDER.length];
}

/** Tage, die ein freigegebener Spieler noch in der Liste erscheint (90 ab Freigabe). */
export const RELEASED_VISIBLE_DAYS = 90;

export function releasedDaysLeft(player, now = Date.now()) {
  if (!player.releasedDate) return RELEASED_VISIBLE_DAYS;
  const deadline =
    new Date(player.releasedDate).getTime() + RELEASED_VISIBLE_DAYS * 86400000;
  return Math.max(0, Math.ceil((deadline - now) / 86400000));
}
